import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import createGlobalFilterSlice, { type GlobalFilterSliceState } from './slices/globalFilter';

const useGlobalFilterStore = create<GlobalFilterSliceState>()(
  persist(createGlobalFilterSlice, {
    name: 'userPreferencesStates',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ vehicleGroupIds: state.vehicleGroupIds, filteredGroups: state.filteredGroups }),
    merge: (persistedState, currentState) => {
      const persisted = persistedState as Partial<GlobalFilterSliceState> | undefined;
      const persistedVehicleGroupIds = Array.isArray(persisted?.vehicleGroupIds) ? persisted.vehicleGroupIds : currentState.vehicleGroupIds;
      return {
        ...currentState,
        ...persisted,
        vehicleGroupIds: persistedVehicleGroupIds.filter(Boolean),
      };
    },
  })
);

export default useGlobalFilterStore;
